export default function ThankYouPopup({ closeThankYou }) {

    return (

        <div
        className="modal fade show"
        id="contactform-modal"
        tabIndex={-1}
        aria-labelledby="contactform-modalLabel"
        aria-modal="true"
        role="dialog"
        style={{ display: 'block', paddingLeft: 0 }}
      >
        <div className="modal-dialog modal-dialog-centered modal-xl">
        <div className="modal-content custom-contact-form">
        
          <div className="modal-header border-0 p-0">
            <button
              type="button"
              className="btn-close"
              onClick={closeThankYou}
              aria-label="Close"
            >
              <img src="./images/model-close-icon.svg" alt="close-icon" className="popup-close-icon" />
            </button>
          </div>
          <div className="modal-body border-0 p-0 text-center">
            <div className="row model-cfs-form-fields text-start">
              <div class="col-md-12 text-center">
                <p className="success-msg">Thank you! Your submission has been received.</p>
              </div>
            </div>
          </div>
          <div className="modal-footer border-0 p-0">
            <button type="button" className="secondary-btn" onClick={closeThankYou}>
              Close
            </button>
          </div>
        </div>
      </div>     
      </div>
    );
  }